export const import_bill_lang={
  TH:{
    header_card: "นำเข้าข้อมูลใบเสร็จรับเงิน",
    bill_id: "รหัสใบเสร็จรับเงิน",
    user_id: "ผู้ออกเอกสาร",
    create_datetime: "วันที่สร้าง",
    status_code: "สถานะการชำระ",
    payment_id: "ประเภทการชำระ",
    flag: "สถานะการใช้งาน",
    pay_datetime: "วันที่ชำระเงิน",
    discount: "ส่วนลด",
    remark: "หมายเหตุ",
    total_price: "วันที่รับเงิน",
    import_excel: "เลือกไฟล์ที่จะ Import",
    download_excel: "Download ไฟล์ Template",
    save: "บันทึกข้อมูล",
    clear: "ล้างข้อมูล",
    approve_detail:"คุณต้องการนำเข้าข้อมูลทั้งหมดนี้ใช่ไหม ?",
    approve_title:"กรุณายืนยัน",
    confirm:"ยืนยัน",
    cancel:"ยกเลิก",
    inform_title:"ไม่สามารถดำเนินการนำเข้า",
    inform_detail:"กรุณาเลือกไฟล์ Excel ก่อนบันทึกข้อมูล",
    inform_titlee:"ไม่สามารถปรับปรุงใบเสร็จรับเงินได้",
    inform_detaill:"กรุณาตรวจสอบไฟล์ Excel ก่อนบันทึกข้อมูล",
    fee_id:"รหัสค่าธรรมเนียม",
    user_name:"ชื่อผู้เสียค่าธรรมเนียม",
    pay: 'วันที่รับเงิน',
    pay_not: 'จำนวนเงิน',
    fee_type:'ประเภทค่าธรรมเนียม'


  },
  EN:{
    fee_type:'fee type',

    header_card: "Import Invoice",
    pay: 'pay date',
    pay_not: 'total price',
    bill_id: "Bill Id",
    user_id: "User Make",
    create_datetime: "Create Date",
    status_code: "Status Payment",
    payment_id: "Payment type",
    flag: "Status",
    pay_datetime: "Payment date",
    discount: "Discount",
    remark: "Remark",
    total_price: "pay date",
    import_excel: "Select file for Import",
    download_excel: "Download Template file",
    inform_detaill :"Unable to update receipt",
    inform_titlee:"Please check Excel file before saving data.",
    save: "Save",
    clear: "Clear",
    approve_detail:"You need import this information right?",
    approve_title:"Please Confirm",
    confirm:"Confirm",
    cancel:"Cancel",
    user_name:"Fullname",
    fee_id:"Fee id",
  }
}
